// UI-only display labels for form-type codes. Codes/functionality are unchanged.
export const FORM_TYPE_LABELS = {
  NEW_METER: "New Meter Installation",
  OLD_REPLACED: "Old Meter Replaced With New Meter",
  REWORK: "Rework in Old Meter",
  SVR: "SVR",
};

export const formTypeLabel = (code) =>
  FORM_TYPE_LABELS[code] || (code || "").replace(/_/g, " ");

// Tailwind text-color class for a material status code, matched by keyword.
export const materialStatusColor = (status) => {
  const s = (status || "").toUpperCase();
  if (/REJECT|DEFECT|SENT_BACK|LOST|DAMAG|FAULT/.test(s)) return "text-red-600";
  if (/INSTALL|COMPLETED|ACCEPT/.test(s)) return "text-emerald-600";
  if (/ACKNOWLEDG/.test(s)) return "text-indigo-600";
  if (/PENDING|REQUEST|ALLOCAT/.test(s)) return "text-amber-600";
  return "text-slate-600";
};

export const materialStatusLabel = (status) => (status || "").replace(/_/g, " ");

